export default {
  // Title bar tab strip.
  tablist: 'Tabs',
  newTab: 'New Tab',
  closeTab: 'Close Tab',
  nextTab: 'Next Tab',
  previousTab: 'Previous Tab',
  splitCount: {
    one: '{{count}} split',
    other: '{{count}} splits',
  },

  // Company and contact sections.
  recordSections: 'Switch view',
  recordSection: 'View: {{section}}',
  'record-overview': 'Overview',
  'record-team': 'Team',
  'record-emails': 'Emails',
  'record-files': 'Files',
  'record-tasks': 'Tasks',
  'record-calls': 'Calls',
  'record-databases': 'Databases',

  // Project sections.
  projectSections: 'Project sections',
  'project-overview': 'Overview',
  'project-tasks': 'Tasks',
};
